<nav class="sidebar sidebar-offcanvas" id="sidebar">
  <ul class="nav">
    <!-- <li class="nav-item nav-profile">
      <a href="javascript:;" class="nav-link">
        <div class="nav-profile-image">
          <img src="assets/images/faces/Dashboard.jpg" alt="profile" />
          <span class="login-status online"></span> -->
    <!--change to offline or busy as needed-->
    <!-- </div>
        <div class="nav-profile-text">
          <span class="font-weight-bold mb-2">{{ userName }}</span>
          <span style="color: #7882A2;" class=" text-small">{{ role }}</span>
        </div>
        <i class="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
      </a>
    </li> -->
    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'dashboard' }">
      <a class="nav-link" routerLink="/dashboard" routerLinkActive #dashboard="routerLinkActive">
        <img src="assets/images/Dashboard.png" alt="Dashboard" />
        <span class="menu-title ml-3">Dashboard</span>
      </a>
    </li>
    <li class="nav-item " [ngClass]="{ 'active active1' : setActiveFlag === 'orders' }">

      <a class="nav-link d-flex align-items-center justify-content-between" (click)="ordersCollapsed = !ordersCollapsed"
        [attr.aria-expanded]="ordersCollapsed" aria-controls="orders">
        <div class="">
          <img src="assets/images/orders.svg" alt="profile" />
          <span class="menu-title ml-3">Orders</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="orders" [ngbCollapse]="!ordersCollapsed">
        <ul class="nav flex-column sub-menu mb-0">
          <li class="nav-item">
            <a class="nav-link" routerLink="orders/orders" routerLinkActive="active"
              #orders="routerLinkActive">Orders</a>
          </li>
          <!-- <li class="nav-item">
            <a
              class="nav-link"
              routerLink="orders/reviews-ratings"
              routerLinkActive="active"
              #reviewsandrating="routerLinkActive"
              >Reviews & Ratings</a
            >
          </li> -->
          <!-- <li class="nav-item">
            <a
              class="nav-link"
              routerLink="orders/likes"
              routerLinkActive="active"
              #likes="routerLinkActive"
              >Likes</a
            >
          </li> -->
          <li class="nav-item">
            <a class="nav-link" routerLink="orders/returns" routerLinkActive="active"
              #returns="routerLinkActive">Returns</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="orders/customizedorders" routerLinkActive="active"
              #returns="routerLinkActive">Customized Orders</a>
          </li>
        </ul>
      </div>
    </li>
    <!-- <li class="nav-item" [ngClass]="{'active' : accordions.isActive || buttons.isActive || badges.isActive || breadcrumbs.isActive || dropdowns.isActive || modals.isActive || progressbar.isActive || pagination.isActive || tabs.isActive || typography.isActive || tooltips.isActive }">
      <a class="nav-link" (click)="uiBasicCollapsed = !uiBasicCollapsed" [attr.aria-expanded]="uiBasicCollapsed" aria-controls="ui-basic">
        <span class="menu-title">Basic UI Elements</span>
        <i class="menu-arrow"></i>
        <i class="mdi mdi-crosshairs-gps menu-icon"></i>
      </a>
      <div class="collapse" id="ui-basic" [ngbCollapse]="!uiBasicCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/accordions" routerLinkActive="active" #accordions="routerLinkActive">Accordions</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/buttons" routerLinkActive="active" #buttons="routerLinkActive">Buttons</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/badges" routerLinkActive="active" #badges="routerLinkActive">Badges</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/breadcrumbs" routerLinkActive="active" #breadcrumbs="routerLinkActive">Breadcrumbs</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/dropdowns" routerLinkActive="active" #dropdowns="routerLinkActive">Dropdowns</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/modals" routerLinkActive="active" #modals="routerLinkActive">Modals</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/progressbar" routerLinkActive="active" #progressbar="routerLinkActive">Progress bar</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/pagination" routerLinkActive="active" #pagination="routerLinkActive">Pagination</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/tabs" routerLinkActive="active" #tabs="routerLinkActive">Tabs</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/typography" routerLinkActive="active" #typography="routerLinkActive">Typography</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/tooltips" routerLinkActive="active" #tooltips="routerLinkActive">Tooltips</a></li>
        </ul>
      </div>
    </li> -->
    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'catlog' }">
      <a class="nav-link d-flex align-items-center justify-content-between" (click)="uiBasicCollapsed = !uiBasicCollapsed" [attr.aria-expanded]="uiBasicCollapsed"
        aria-controls="catlog">
        <div class="">
          <img src="assets/images/catalogue.svg" alt="Catalogue" />
          <span class="menu-title ml-3">Catalogue</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="ui-basic" [ngbCollapse]="!uiBasicCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a class="nav-link" routerLink="catlog/categories" routerLinkActive="active"
              #categories="routerLinkActive">Categories</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="catlog/products" routerLinkActive="active"
              #products="routerLinkActive">Products</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="catlog/productsizes" routerLinkActive="active"
              #productsizes="routerLinkActive">Sizes</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="catlog/productcolors" routerLinkActive="active"
              #productcolors="routerLinkActive">Colors</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="catlog/materials" routerLinkActive="active"
              #materials="routerLinkActive">Materials</a>
          </li>
          <!-- <li class="nav-item">
            <a
              class="nav-link"
              routerLink="catlog/productdesigner"
              routerLinkActive="active"
              #productdesigners="routerLinkActive"
              >Designers/Brand</a
            >
          </li> -->

          <li class="nav-item">
            <a class="nav-link" routerLink="catlog/filters" routerLinkActive="active"
              #filters="routerLinkActive">Filters</a>
          </li>
        </ul>
      </div>
    </li>
    <!-- <li
      class="nav-item"
      [ngClass]="{
        active:
          events.isActive ||
          extensions.isActive ||
          installer.isActive ||
          marketplace.isActive ||
          modifications.isActive
      }"
    >
      <a
        class="nav-link"
        (click)="extensionsCollapsed = !extensionsCollapsed"
        [attr.aria-expanded]="extensionsCollapsed"
        aria-controls="extensions"
      >
        <span class="menu-title">Extensions</span>
        <i class="menu-arrow"></i>
        <i class="mdi mdi-google-circles-extended menu-icon"></i>
      </a>
      <div
        class="collapse"
        id="extensions"
        [ngbCollapse]="!extensionsCollapsed"
      >
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="extensions/marketplace"
              routerLinkActive="active"
              #marketplace="routerLinkActive"
              >Marketplace</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="extensions/installer"
              routerLinkActive="active"
              #installer="routerLinkActive"
              >Installer</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="extensions/extensions"
              routerLinkActive="active"
              #extensions="routerLinkActive"
              >Extensions</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="extensions/modifications"
              routerLinkActive="active"
              #modifications="routerLinkActive"
              >Modifications</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="extensions/events"
              routerLinkActive="active"
              #events="routerLinkActive"
              >Events</a
            >
          </li>
        </ul>
      </div>
    </li> -->



    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'design' }">

      <a class="nav-link" routerLink="/design" routerLinkActive #designers="routerLinkActive">
        <img src="assets/images/Brands_icon_menu_bar.svg" alt="Brands" />
        <span class="menu-title ml-3">Brands</span>
      </a>
    </li>


    <!-- <li
      class="nav-item"
      [ngClass]="{
        active: designrequest.isActive || designers.isActive
      }"
    >
      <a
        class="nav-link"
        (click)="designCollapsed = !designCollapsed"
        [attr.aria-expanded]="designCollapsed"
        aria-controls="design"
      >
        <span class="menu-title">Design</span>
        <i class="menu-arrow"></i>
        <i class="mdi mdi-tshirt-crew menu-icon"></i>
      </a>
      <div class="collapse" id="design" [ngbCollapse]="!designCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="design/designers"
              routerLinkActive="active"
              #designers="routerLinkActive"
              ></a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="design/designrequest"
              routerLinkActive="active"
              #designrequest="routerLinkActive"
              > </a
            >
          </li>
        </ul>
      </div>
    </li> -->
    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'customers' }">

      <a class="nav-link" routerLink="customers/customers" routerLinkActive #designers="routerLinkActive">
        <img src="assets/images/customers.svg" alt="Brands" />
        <span class="menu-title ml-3">Customers</span>
      </a>
    </li>
    <!-- <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'customers' }">

      <a class="nav-link d-flex align-items-center justify-content-between" (click)="customersCollapsed = !customersCollapsed" [attr.aria-expanded]="customersCollapsed"
        aria-controls="customers">
        <div class="">
          <img src="assets/images/customers.svg" alt="Customers" />
          <span class="menu-title ml-3">Customers</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="customers" [ngbCollapse]="!customersCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a class="nav-link" routerLink="customers/customers" routerLinkActive="active"
              #customers="routerLinkActive">Customers</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="customers/customergroups" routerLinkActive="active"
              #customergroups="routerLinkActive">Customer Groups</a>
          </li>
        </ul>
      </div>
    </li> -->

    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'delivery' }">
      <a class="nav-link d-flex align-items-center justify-content-between" (click)="deliveryCollapsed = !deliveryCollapsed" [attr.aria-expanded]="deliveryCollapsed"
        aria-controls="locations">
        <div class="">
          <img src="assets/images/delivery-module.svg" alt="Delivery" />
          <span class="menu-title ml-3">Delivery</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="locations" [ngbCollapse]="!deliveryCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a class="nav-link" routerLink="delivery" routerLinkActive="active"
              #locations="routerLinkActive">Locations</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="delivery/slot" routerLinkActive="active" #slots="routerLinkActive">Slot</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="delivery/delivery-agent" routerLinkActive="active"
              #deliveryagent="routerLinkActive">Delivery Agent</a>
          </li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'feedback' }">

      <a class="nav-link d-flex align-items-center justify-content-between" (click)="feedbackCollapsed = !feedbackCollapsed" [attr.aria-expanded]="feedbackCollapsed"
        aria-controls="feedback">
        <div class="">
          <img src="assets/images/feedback.svg" alt="FeedBack" />
          <span class="menu-title ml-3">FeedBack</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="feedback" [ngbCollapse]="!feedbackCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a class="nav-link" routerLink="feedback/reviewsratings" routerLinkActive="active"
              #reviewsratings="routerLinkActive">Review & Ratings</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="feedback/productlikes" routerLinkActive="active"
              #productlikes="routerLinkActive">Likes</a>
          </li>
        </ul>
      </div>
    </li>









    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'marketing' }">
      <a class="nav-link d-flex align-items-center justify-content-between" (click)="marketingCollapsed = !marketingCollapsed" [attr.aria-expanded]="marketingCollapsed"
        aria-controls="marketing">
        <div class="">
          <img src="assets/images/marketing.svg" alt="Marketing" />
          <span class="menu-title ml-3">Marketing</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="marketing" [ngbCollapse]="!marketingCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a class="nav-link" routerLink="marketing/coupon" routerLinkActive="active"
              #coupon="routerLinkActive">Coupon</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="marketing/mail" routerLinkActive="active" #mail="routerLinkActive">Mail</a>
          </li>
        </ul>
      </div>
    </li>

    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'sales' }">
      <a class="nav-link" routerLink="/sales" routerLinkActive #sales="routerLinkActive">
        <img src="assets/images/reports.svg" alt="Reports" />
        <span class="menu-title ml-3">Reports</span>
      </a>
    </li>

    <li class="nav-item" [ngClass]="{ 'active active1' : setActiveFlag === 'analytics' }">
      <a class="nav-link d-flex align-items-center justify-content-between" (click)="analyticsCollapsed = !analyticsCollapsed" [attr.aria-expanded]="analyticsCollapsed"
        aria-controls="analytics">
        <div class="">
          <img src="assets/images/analytics.svg" alt="Analytics" />
          <span class="menu-title ml-3">Analytics</span>
        </div>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="analytics" [ngbCollapse]="!analyticsCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item">
            <a class="nav-link" routerLink="analytics/active-users" routerLinkActive="active"
              #activeusers="routerLinkActive">Active Users</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="analytics/traffic" routerLinkActive="active"
              #traffic="routerLinkActive">Traffic</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="analytics/behaviour" routerLinkActive="active"
              #behaviour="routerLinkActive">Behaviour</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="analytics/seo" routerLinkActive="active" #seo="routerLinkActive">SEO</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="analytics/referral-traffic" routerLinkActive="active"
              #referraltraffic="routerLinkActive">Referral Traffic</a>
          </li>
        </ul>
      </div>
    </li>
    <!-- <li class="nav-item" [ngClass]="{ active: marketplace.isActive }">
      <a
        class="nav-link"
        routerLink="/marketplace"
        routerLinkActive
        #marketplace="routerLinkActive"
      >
        <span class="menu-title">Marketplace</span>
        <i class="mdi mdi-home-map-marker menu-icon"></i>
      </a>
    </li> -->
    <!-- <li class="nav-item" >
        <a class="nav-link" (click)="extensionsCollapsed  = !extensionsCollapsed "  [attr.aria-expanded]="extensionsCollapsed " aria-controls="extensions">
          <span class="menu-title">Extensions</span>
          <i class="menu-arrow"></i>
          <i class="mdi mdi-medical-bag menu-icon"></i>
        </a>
        <div class="collapse" id="extensions" [ngbCollapse]="!extensionsCollapsed">

        </div>
          </li>

          <li class="nav-item" >
            <a class="nav-link" (click)="designCollapsed  = !designCollapsed "  [attr.aria-expanded]="designCollapsed " aria-controls="design">
              <span class="menu-title">Design</span>
              <i class="menu-arrow"></i>
              <i class="mdi mdi-medical-bag menu-icon"></i>
            </a>
            <div class="collapse" id="design" [ngbCollapse]="!designCollapsed"> </div>
              </li>

              <li class="nav-item" >
                <a class="nav-link" (click)="salesCollapsed  = !salesCollapsed "  [attr.aria-expanded]="salesCollapsed " aria-controls="sales">
                  <span class="menu-title">Sales</span>
                  <i class="menu-arrow"></i>
                  <i class="mdi mdi-medical-bag menu-icon"></i>
                </a>
                <div class="collapse" id="sales" [ngbCollapse]="!salesCollapsed"> </div>
                  </li>
                  <li class="nav-item" >
                    <a class="nav-link" (click)="customersCollapsed  = !customersCollapsed "  [attr.aria-expanded]="customersCollapsed " aria-controls="customers">
                      <span class="menu-title">Customers</span>
                      <i class="menu-arrow"></i>
                      <i class="mdi mdi-medical-bag menu-icon"></i>
                    </a>
                    <div class="collapse" id="customers" [ngbCollapse]="!customersCollapsed"> </div>
                      </li>


                      <li class="nav-item" >
                        <a class="nav-link" (click)="marketingCollapsed  = !marketingCollapsed "  [attr.aria-expanded]="marketingCollapsed " aria-controls="marketing">
                          <span class="menu-title">Marketing</span>
                          <i class="menu-arrow"></i>
                          <i class="mdi mdi-medical-bag menu-icon"></i>
                        </a>
                        <div class="collapse" id="marketing" [ngbCollapse]="!marketingCollapsed"> </div>
                          </li>


                          <li class="nav-item" >
                            <a class="nav-link" (click)="systemCollapsed  = !systemCollapsed "  [attr.aria-expanded]="systemCollapsed " aria-controls="system">
                              <span class="menu-title">System</span>
                              <i class="menu-arrow"></i>
                              <i class="mdi mdi-medical-bag menu-icon"></i>
                            </a>
                            <div class="collapse" id="system" [ngbCollapse]="!systemCollapsed"> </div>
                              </li>

                              <li class="nav-item" >
                                <a class="nav-link" (click)="reportsCollapsed  = !reportsCollapsed "  [attr.aria-expanded]="reportsCollapsed " aria-controls="reports">
                                  <span class="menu-title">Reports</span>
                                  <i class="menu-arrow"></i>
                                  <i class="mdi mdi-medical-bag menu-icon"></i>
                                </a>
                                <div class="collapse" id="reports" [ngbCollapse]="!reportsCollapsed"> </div>
                                  </li> -->

    <!--
    <li class="nav-item" [ngClass]="{ 'active': forms.isActive }">
      <a class="nav-link" routerLink="forms/basic-elements" routerLinkActive #forms="routerLinkActive">
        <span class="menu-title">Form elements</span>
        <i class="mdi mdi-format-list-bulleted menu-icon"></i>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active': charts.isActive }">
      <a class="nav-link" routerLink="charts/chartjs" routerLinkActive #charts="routerLinkActive">
        <span class="menu-title">Charts</span>
        <i class="mdi mdi-chart-bar menu-icon"></i>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active': tables.isActive }">
      <a class="nav-link" routerLink="tables/basic-table" routerLinkActive #tables="routerLinkActive">
        <span class="menu-title">Tables</span>
        <i class="mdi mdi-table-large menu-icon"></i>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active': icons.isActive }">
      <a class="nav-link" routerLink="icons/mdi" routerLinkActive #icons="routerLinkActive">
        <span class="menu-title">Icons</span>
        <i class="mdi mdi-contacts menu-icon"></i>
      </a>
    </li> -->
  </ul>
</nav>